// extracted by mini-css-extract-plugin
module.exports = {"root":"_4bb245","stacked":"_a71f38","icon":"_af67a3","multiline":"_d6b28e","gem":"_2c2b62","content":"_16ddaf","title":"_ec6135","apps":"_82cb26"};